import store from '@/store/index';
const isSupplier = !!store.state.supplier;
export default {
    configuration: true,
    'buttonList': [
        {
            'type': 'text',
            'class': 'bigData-btn-fti-refresh',
            'icon': 'el-icon-refresh',
            'label': '刷新',
            'size': 'small',
            'event': 'refresh',
            'ifHas': false
        },
        {
            'type': 'text',
            'class': 'bigData-btn-fti-add',
            'icon': 'el-icon-circle-plus-outline',
            'label': '新增',
            'size': 'small',
            'event': 'add',
            'ifHas': false
        },
        {
            'type': 'text',
            'class': 'bigData-btn-fti-delete',
            'icon': 'el-icon-delete',
            'label': '删除',
            'size': 'small',
            'event': 'deleteData',
            'ifHas': isSupplier
        },
        {
            'type': 'text',
            'class': 'bigData-btn-fti-on',
            'icon': 'el-icon-circle-check',
            'label': '启用',
            'size': 'small',
            'event': 'start'
        },
        {
            'type': 'text',
            'class': 'bigData-btn-fti-off',
            'icon': 'el-icon-circle-close',
            'label': '停用',
            'size': 'small',
            'event': 'stop',
            'ifHas': '04000097'
        }
    ],
    'table': {
        'switchType': true,
        'tableCut': false,
        'selectBtn': true,
        'height': 'calc(100vh - 412px)',
        'statesY': '启用',
        'statesN': '停用',
        'columns': [
            {
                'label': '叉车序号',
                'prop': 'serialNum',
                'width': '150px'
            },
            {
                'label': '叉车编码',
                'prop': 'forkliftCode',
                'width': '150px'
            },
            {
                'label': '是否为新车',
                'prop': 'newFlag',
                'width': '150px'
            },
            {
                'label': '叉车状态',
                'prop': 'enableFlag',
                'width': '150px'
            },
            {
                'label': '出厂时间',
                'prop': 'deliveryDate',
                'width': '150px'
            },
            {
                'label': '设备类型',
                'prop': 'deviceType',
                'width': '150px'
            },
            {
                'label': '设备品牌',
                'prop': 'deviceBrand',
                'width': '150px'
            },
            {
                'label': '型号',
                'prop': 'model',
                'width': '150px'
            },
            {
                'label': '核载重量',
                'prop': 'payload',
                'width': '150px'
            },
            {
                'label': '创建时间',
                'prop': 'createTime',
                'width': '150px'
            },
            {
                'label': '创建人',
                'prop': 'createUserName',
                'width': '150px'
            },
            {
                'label': '更新时间',
                'prop': 'updateTime',
                'width': '150px'
            },
            {
                'label': '更新人',
                'prop': 'updateUserName',
                'width': '150px'
            }
        ],
        'action': [],
        'leftWidth': 250
    },
    'page': {
        'layout': 'total, sizes, prev, pager, next, jumper',
        'pageSize': 10
    },
    formData: {
        id: '',
        relationId: '',
        serialNum: '',
        forkliftCode: '',
        deliveryDate: '',
        enableFlag: 1, // 0启用 1停用
        deviceType: '',
        deviceBrand: '',
        model: '',
        payload: '',
        newFlag: false // 0是 1否
    }
};